import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
	selector: "jhm-toast",
	imports: [CommonModule],
	templateUrl: "./toast.component.html",
	styleUrl: "./toast.component.scss"
})
export class ToastComponent {
    @Input() message: string = "";
    @Input() type: "success" | "error" | "info" = "info";
    @Output() closed: EventEmitter<void> = new EventEmitter<void>();
}
